import { render, staticRenderFns } from "./ItemPrice.vue?vue&type=template&id=27592de8&"
import script from "./ItemPrice.vue?vue&type=script&lang=js&"
export * from "./ItemPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/plugin-ceres/plugin-ceres/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('27592de8')) {
      api.createRecord('27592de8', component.options)
    } else {
      api.reload('27592de8', component.options)
    }
    module.hot.accept("./ItemPrice.vue?vue&type=template&id=27592de8&", function () {
      api.rerender('27592de8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/ItemPrice.vue"
export default component.exports